import React from 'react';
import EmptyState, { emptyStateIllustrationSize } from '@weave-mui/empty-state';
import Illustration, { illustrationVariants } from '@weave-mui/illustration';

const DEFAULT_EMPTY_STATE_SX = {
  marginLeft: 'auto',
  marginRight: 'auto',
  marginTop: '24px',
  width: '100%',
  maxWidth: '1086px',
};

/**
 * StandardEmptyState
 *
 * Shared, app-standard wrapper around `@weave-mui/empty-state` that keeps a consistent
 * layout (centering/max width), default illustration, and default illustration sizing.
 *
 * Use feature-level wrappers (e.g., EmptyProjectsState) to provide copy and CTAs.
 *
 * @param {Object} props - Component props
 * @param {string} props.headline - Main headline text
 * @param {string} props.tagline - Secondary text shown under the headline
 * @param {string} [props.supportingText=''] - Optional supporting text
 * @param {React.ReactNode} [props.callToAction] - Optional CTA element (usually a button)
 * @param {Object} [props.sx={}] - Optional style overrides merged on top of defaults
 * @param {string} [props.illustrationVariant=illustrationVariants.FIRST_USE] - Illustration variant
 * @param {string} [props.illustrationSize=emptyStateIllustrationSize.MEDIUM] - Illustration size
 * @returns {JSX.Element}
 */
const StandardEmptyState = ({
  headline,
  tagline,
  supportingText = '',
  callToAction,
  sx = {},
  illustrationVariant = illustrationVariants.FIRST_USE,
  illustrationSize = emptyStateIllustrationSize.MEDIUM,
}) => {
  return (
    <EmptyState
      headline={headline}
      illustration={<Illustration variant={illustrationVariant} />}
      tagline={tagline}
      supportingText={supportingText}
      callToAction={callToAction}
      illustrationSize={illustrationSize}
      sx={{
        ...DEFAULT_EMPTY_STATE_SX,
        ...sx,
      }}
    />
  );
};

export default StandardEmptyState;

